"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var _styled = _interopRequireDefault(require("@emotion/styled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n        width: 40px;\n        height: 40px;\n        background-color: #333;\n        margin: 10px;\n        animation: sk-rotateplane 1.2s infinite ease-in-out;\n        @keyframes sk-rotateplane {\n          0% { \n            transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n          } 50% { \n            transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n          } 100% { \n            transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n          }\n        }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

class LoadingComponent extends _react.default.PureComponent {
  render() {
    const DefaultSpinner = (0, _styled.default)('div')(_templateObject());
    return (0, _core.jsx)("div", null, (0, _core.jsx)(DefaultSpinner, null), this.props.message);
  }

}

exports.default = LoadingComponent;